module.exports = __webpack_public_path__ + "img/1-i-icon-language-vi.9c8f5fa1.svg";